<script setup>
import { useDetectDevice } from '@/composables/device'

import CompaniesView from '@/components/planner/CompaniesView.vue'
import CompaniesGrid from '@/components/planner/CompaniesGrid.vue'

const { isMobile } = useDetectDevice()

</script>
<template>
  <companies-view v-if="isMobile" />
  <companies-grid v-else />
</template>
